import React from 'react';
import { Form } from 'react-bootstrap';
import styles from './styles.module.scss';

interface StatusFilterProps {
  selectedStatus: string;
  onChange: (status: string) => void;
}

const STATUS_OPTIONS = [
  { value: 'all', label: 'All Statuses' },
  { value: 'active', label: 'Active' },
  { value: 'completed', label: 'Completed' },
  { value: 'past_due', label: 'Past Due' },
];

export const StatusFilter: React.FC<StatusFilterProps> = ({ selectedStatus, onChange }) => {
  return (
    <div className={styles.filterSection}>
      {STATUS_OPTIONS.map(({ value, label }) => (
        <Form.Check
          key={value}
          type="radio"
          id={`status-${value}`}
          label={label}
          name="status"
          checked={selectedStatus === value}
          onChange={() => onChange(value)}
          className={styles.filterRadio}
        />
      ))}
    </div>
  );
};